import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=2fd3881c&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=2fd3881c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3881c",
  null
  
)

export default component.exports